import React, { Component } from 'react';
import classnames from 'classnames';
import { Column, Table, AutoSizer } from 'react-virtualized';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Spinner } from '@blueprintjs/core';
import history from '../../../helpers/history';

class LeftMenu extends Component {
    openModal = () => {
        const { clientType } = this.props.match.params;
        const isRecipient = !clientType || clientType === 'recipients';
        const event = new CustomEvent(isRecipient ? 'open-add-recipient-modal' : 'open-add-donor-modal');
        window.dispatchEvent(event);
    }
    render() {
        const { clientType, clientId } = this.props.match.params;
        const { recipient: { recipients }, donor: {donors}} = this.props;
        const isRecipient = !clientType || clientType === 'recipients';
        const list = isRecipient ? recipients : donors;
        const listId = parseInt(clientId, 10);
        return (
            <div className="left-menu-container">
                <div className="left-menu-title-row">
                    <div className="full-width-title">{
                        isRecipient ? 'Recipients' : 'Donors'
                    }</div>
                    <div className="action" onClick={() => this.openModal()}><span className="pt-icon-standard pt-icon-plus" /></div>
                </div>
                <ListTable {...this.props}
                    list={list}
                    listId={listId}
                    isRecipient={isRecipient}
                    onSearch={this.onSearch} />
            </div>
        );
    }
}

class ListTable extends Component {
    state = {
        searchValue: ''
    }
    onChangeTab = tab => {
        history.push(`/dashboard/${tab}`);
    }
    onRowClick = ({ rowData }) => {
        const {clientType} = this.props.match.params;
        history.push(`/dashboard/${clientType || 'recipients'}/${rowData.id}`);
    }
    onChange = ({ target: { value }}) => {
        this.setState({ searchValue: value });
    }
    _nameCell = ({ rowData: { first_name, middle_name, last_name }}) => {
        return (
            <div role='row'>
                {`${first_name} ${middle_name} ${last_name}`}
            </div>
        );
    }
    _locationCell = ({ rowData }) => {
        return (
            <div role='row'>
                { this.props.isRecipient ?
                    `${rowData.city_of_school || 'N/A'}, ${rowData.country_of_school || 'N/A'}`
                    : `${rowData.city_of_residence || 'N/A'}, ${rowData.country_of_residence || 'N/A'}`
                }
            </div>
        );
    }
    onSearch = () => {
        const { list, isRecipient } = this.props;
        let { searchValue } = this.state;
        searchValue = searchValue.toLowerCase();
        let newList = list;
        // Filter list if search value exists.
        if (searchValue !== '') {
            const a = new Date();
            if (isRecipient) {
                newList = list.filter(recipient => {
                    const { first_name, middle_name, last_name, city_of_school, country_of_school, id } = recipient;
                    return (
                        `${id}`.includes(searchValue) ||
                        `${first_name} ${middle_name} ${last_name}`.toLowerCase().includes(searchValue) ||
                        `${city_of_school} ${country_of_school}`.toLowerCase().includes(searchValue)
                    );
                });
            } else {
                newList = list.filter(donor => {
                    const { first_name, middle_name, last_name, country_of_residence, city_of_residence, street_address, id } = donor;
                    return (
                        `${id}`.includes(searchValue) ||
                        `${first_name} ${middle_name} ${last_name}`.toLowerCase().includes(searchValue) ||
                        `${country_of_residence} ${city_of_residence}`.toLowerCase().includes(searchValue)
                    );
                });
            }
            const b = new Date();
            // console.log(`Filtered ${list.length} data items in ${(b - a)/1000} seconds`);
        }

        return newList;
    }
    render() {
        const currentUser = this.props.user;
        const { listId, isRecipient, recipient: { allLoading }, general: { debugMode }} = this.props;
        const list = this.onSearch();
        let scrollToIndex;
        if (listId) {
            scrollToIndex = list.findIndex(listItem => listItem.id === listId);
        }
        return (
            <div className="left-menu-content">
                <div className="left-menu-filter">
                    <input className="pt-input pt-fill"
                        value={this.state.searchValue}
                        onChange={this.onChange}
                        placeholder={`Search ${isRecipient ? 'Recipient' : 'Donor'} By ID, Name or Location`}
                        dir="auto" />
                </div>
                { currentUser.data.is_super_admin || currentUser.data.is_corporate_admin ?
                    <div className="left-menu-tabs">
                        <div className={classnames('left-menu-tab', {selected: isRecipient })} onClick={() => this.onChangeTab('recipients')}>Recipients</div>
                        <div className={classnames('left-menu-tab', {selected: !isRecipient })} onClick={() => this.onChangeTab('donors')}>Donors</div>
                    </div> : null
                }
                <div className="recipients-table">
                    { allLoading ?
                        <div className="spinner-container">
                            <Spinner large />
                        </div> :
                        <AutoSizer>
                            {({ width, height }) => (
                                <Table className="virtualized-table"
                                    width={width}
                                    height={height}
                                    headerHeight={35}
                                    rowHeight={35}
                                    scrollToIndex={scrollToIndex}
                                    rowClassName={row => ({ 'selected': row.index >= 0 && list[row.index].id === listId })}
                                    onRowClick={this.onRowClick}
                                    rowCount={list.length}
                                    rowGetter={({ index }) => list[index]}>
                                    { debugMode ? <Column label='ID' dataKey='id' width={35} /> : null }
                                    <Column width={200} dataKey='name' label='Name' cellRenderer={(data) => this._nameCell(data)} flexGrow={1} />
                                    <Column width={150} dataKey='location' label='Location' cellRenderer={(data) => this._locationCell(data)}  />
                                </Table>
                            )}
                        </AutoSizer>
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(connect(
    (state) => ({
        recipient: state.recipient,
        general: state.general,
        donor: state.donor,
        user: state.user
    }),
    {}
)(LeftMenu));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/LeftMenu.jsx